<template>
  <div class="station-list-container">
      <div class="station-list">
        <div class="safe-top">
          <el-button
            class="close-list-button"
            type="text"
            icon="el-icon-close"
            @click="$emit('close')">
          </el-button>
        </div>
        <div class="list-header">
          <h1>Stations <span>{{ stations.length }} stations available</span></h1>
          <div class="tabber">
            <div class="tab-button" :class="{ active: filter === '@ALL' }" @click="setFilter('@ALL')">All</div>
            <div class="tab-button" :class="{ active: filter === '@MEMBER' }" @click="setFilter('@MEMBER')">Member</div>
            <div class="tab-button" :class="{ active: filter === '@!MEMBER' }" @click="setFilter('@!MEMBER')">Not member</div>
          </div>
          <div class="search">
            <i class="el-icon-search" />
            <input type="text" @input="$emit('input', $event.target.value)" placeholder="Search" />
          </div>
          <h1 class="small">Station list</h1>
        </div>
        <transition-group name="swing-right" tag="div">
          <station
            v-for="station in stations"
            :key="station.id"
            :station="station"
            :selected="selectedStationId === station.id"
            @highlight="$emit('select', station)" />
        </transition-group>
    </div>
  </div>
</template>

<script>
import Station from './Station'

export default {
  name: 'StationList',
  components: { Station },
  props: {
    selectedStationId: {
      type: String,
      required: true
    },
    stations: {
      type: Array,
      required: true
    },
    filter: {
      type: String,
      required: true
    }
  },
  watch: {
    showList (val) {
      setTimeout(() => {
        if (val) {
          this.animateClose = true
        } else {
          this.animateClose = false
        }
      }, 300)
      this.$emit('close')
    }
  },
  methods: {
    setFilter (filter) {
      this.$emit('filter', filter)
    }
  },
  mounted () {
    setTimeout(() => {
      this.animateClose = true
    })
  }
}
</script>

<style lang="scss" scoped>
  .close-list-button {
    position: absolute;
    right: 0px;
    top: 0px;
    font-size: 18px;
    padding: 20px;
    margin: 0;
  }

  .station-list-container {
    display: flex;
    align-items: flex-start;
    position: absolute;
    top: 0px;
    right: 0px;
    height: calc(100vh - 60px);
    z-index: 9999;
    width: 350px;

    button {
      margin-right: 20px !important;
      margin-top: 20px;
    }

    @include breakpoint (xs) {
      width: 100%;
      height: calc(100vh - 50px);    
    }
  }

  .station-list {
    background-color: rgba(white, 1);
    height: 100%;
    width: 100%;
    -webkit-box-shadow: 0px 0px 30px 0px rgba($text-light,.1);
    -moz-box-shadow: 0px 0px 30px 0px rgba($text-light,.1);
    box-shadow: 0px 0px 30px 0px rgba($text-light,.1);
  }

  .list-header {
    background-color: white;

    h1 {
      font-size: 22px;
      line-height: 22px;
      font-weight: 500;
      color: $text;
      margin: 0;
      padding: 60px 20px 20px 20px;

      display: flex;
      flex-direction: column;

      &.small {
        font-size: 12px;
        color: $text-light;
        text-transform: uppercase;
        font-weight: 600;
        padding: 30px 20px 20px 20px;
      }

      span {
        color: $text-light;
        font-size: 12px;
        font-weight: 600;
        margin-top: 3px;
      }
    }

    .tabber {
      width: 100%;
      height: 60px;
      border-top: 1px solid $border;
      border-bottom: 1px solid $border;
      display: flex;
      align-items: center;
      padding: 0px 20px;

      .tab-button {
        cursor: pointer;
        font-size: 12px;
        margin-right: 20px;
        font-weight: 500;
        color: $text-light;
        transition: color .2s linear;

        &.active {
          color: $main;
        }
      }
    }

    .search {
      width: calc(100% - 40px);
      margin: 0 auto;
      position: relative;
      margin-top: 20px;

      i {
        position: absolute;
        left: 15px;
        top: 50%;
        transform: translateY(-50%);
        color: $text-light;
      }

      input { 
        border: 1px solid $border;
        border-radius: 500px;
        background-color: #FAFAFB;
        height: 40px;
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;

        &::placeholder {
          color: $text-light;
        }

        &:focus {
            outline: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/StationList.vue